import * as monaco from "monaco-editor";
import * as Utils from "./utils";
export class CursorWidget {
    constructor({ codeEditor, widgetId, color, label, range, tooltipDuration = 1000, opacity = "1.0", onDisposed, }) {
        this._editor = codeEditor;
        this._tooltipDuration = tooltipDuration;
        this._id = `monaco-remote-cursor-${widgetId}`;
        this._onDisposed = onDisposed;
        this._color = color;
        this._content = label;
        this._opacity = opacity;
        this._domNode = this._createWidgetNode();
        this._scrollListener = this._editor.onDidScrollChange(() => {
            this._updateTooltipPosition();
        });
        this.updatePosition(range);
        this._hideTimer = null;
        this._editor.addContentWidget(this);
        this._disposed = false;
    }
    getId() {
        return this._id;
    }
    getDomNode() {
        return this._domNode;
    }
    getPosition() {
        return this._position;
    }
    updatePosition(range) {
        this._updatePosition(range);
        setTimeout(() => this._showTooltip(), 0);
    }
    updateContent(userName) {
        if (typeof userName !== "string" || userName === this._content) {
            return;
        }
        this._tooltipNode.textContent = userName;
    }
    dispose() {
        if (this._disposed) {
            return;
        }
        this._editor.removeContentWidget(this);
        if (this._scrollListener !== null) {
            this._scrollListener.dispose();
        }
        this._disposed = true;
        this._onDisposed();
    }
    isDisposed() {
        return this._disposed;
    }
    _updatePosition(range) {
        this._position = {
            position: range.getEndPosition(),
            preference: [
                monaco.editor.ContentWidgetPositionPreference.ABOVE,
                monaco.editor.ContentWidgetPositionPreference.BELOW,
            ],
        };
        this._editor.layoutContentWidget(this);
    }
    _showTooltip() {
        this._updateTooltipPosition();
        if (this._hideTimer !== null) {
            clearTimeout(this._hideTimer);
        }
        else {
            this._setTooltipVisible(true);
        }
        this._hideTimer = setTimeout(() => {
            this._setTooltipVisible(false);
            this._hideTimer = null;
        }, this._tooltipDuration);
    }
    _updateTooltipPosition() {
        const distanceFromTop = this._domNode.offsetTop - this._editor.getScrollTop();
        if (distanceFromTop - this._tooltipNode.offsetHeight < 5) {
            this._tooltipNode.style.top = `${this._tooltipNode.offsetHeight + 2}px`;
        }
        else {
            this._tooltipNode.style.top = `-${this._tooltipNode.offsetHeight}px`;
        }
        this._tooltipNode.style.left = "0";
    }
    _setTooltipVisible(visible) {
        if (visible) {
            this._tooltipNode.style.display = "block";
        }
        else {
            this._tooltipNode.style.display = "none";
        }
    }
    _colorWithCSSVars(property) {
        const varName = `--color-${property}-${CursorWidget.WIDGET_NODE_CLASSNAME}`;
        return `var(${varName}, ${this._color})`;
    }
    _getTextColor() {
        const rgb = Utils.hexToRgb(this._color);
        const brightness = Math.round((rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000);
        return brightness >= 125 ? "#000000" : "#ffffff";
    }
    _createTooltipNode() {
        const tooltipNode = document.createElement("div");
        tooltipNode.style.borderColor = this._colorWithCSSVars("border");
        tooltipNode.style.backgroundColor = this._colorWithCSSVars("bg");
        tooltipNode.style.color = this._getTextColor();
        tooltipNode.style.opacity = this._opacity;
        tooltipNode.style.borderRadius = "2px";
        tooltipNode.style.fontSize = "12px";
        tooltipNode.style.padding = "2px 8px";
        tooltipNode.style.whiteSpace = "nowrap";
        tooltipNode.textContent = this._content;
        const className = `${CursorWidget.TOOLTIP_NODE_CLASSNAME}-${this._color.replace("#", "")}`;
        tooltipNode.classList.add(className, CursorWidget.TOOLTIP_NODE_CLASSNAME);
        return tooltipNode;
    }
    _createWidgetNode() {
        Utils.validateTruth(document != null, "This package must run on browser!");
        const widgetNode = document.createElement("div");
        widgetNode.style.height = "20px";
        widgetNode.style.paddingBottom = "0px";
        widgetNode.style.transition = "all 0.1s linear";
        this._tooltipNode = this._createTooltipNode();
        widgetNode.appendChild(this._tooltipNode);
        widgetNode.classList.add("monaco-editor-overlaymessage", CursorWidget.WIDGET_NODE_CLASSNAME);
        return widgetNode;
    }
}
CursorWidget.WIDGET_NODE_CLASSNAME = "firepad-remote-cursor";
CursorWidget.TOOLTIP_NODE_CLASSNAME = "firepad-remote-cursor-message";
